import TipoIndicador from "..";
import ADF from "entity/Indicador/ADF";
import AFC from "entity/Indicador/AFC";
import TAH from "entity/Indicador/TAH";
import ADH from "entity/Indicador/ADH";
import ADN from "entity/Indicador/ADN";
import AVL from "entity/Indicador/AVL";
import ADC from "entity/Indicador/ADC";
import ADO from "entity/Indicador/ADO";
import PCorte from "entity/Indicador/PCorte";
import AH from "entity/Indicador/AH"
import DC from "entity/Indicador/DC";
import DCor from "entity/Indicador/DCor";
import AC from "entity/Indicador/AC";
import EnlDesp from "entity/Indicador/EnlDesp";
import PEsc from "entity/Indicador/PEsc";
import Torr from "entity/Indicador/Torr";

export default class TratosSoca extends TipoIndicador {
    static get abbrev() {
        return 'tratosCanaSoca';
    }
    static get fullName() {
        return "Tratos / Cana Soca";
    }

    static get field() {
        return 'tratosCanaSoca';
    }

    static get indicadores() {
        return [AC, ADF, AFC, AH, ADH, ADN, ADC, ADO, AVL, DC, DCor, EnlDesp, PCorte, PEsc, TAH, Torr]
    }
}
